import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'resultsStats',
  initialState: {
    data: {
      publications: [],
      selectedPublication: null,
      resume: {
        active_students: 0,
        active_teachers: 0,
        registered_students: 0,
        registered_teachers: 0,
        total_classes: 0,
        total_students_usage_time: 0,
        total_teachers_usage_time: 0,
        total_centers: 0,
      },
      stats: [],
    },
  },
  reducers: {
    setStats: (state, { payload: obj }) => {
      state.data = { ...state.data, ...obj };
    },
    setCurrentPublication: (state, { payload: publication }) => {
      state.data.selectedPublication = publication;
    },
  },
});

export const { setStats, setCurrentPublication } = slice.actions;

export default slice.reducer;

export const selectStats = (state) => state.resultsStats.data;
